<template>
    <div container>
        <div id="content-container">
            <div id="banner">
                Personality test
            </div>
            <div class="item">
                <div class="left"></div>
                <div class="content" @click="forward('Myers-Briggs','/src//assets/personality/test1.png')">
                    <div class="image">
                        <img :src="require('/src//assets/personality/test1.png')" alt="evil">
                    </div>
                    <h3>Myers-Briggs</h3>
                </div>
                <div class="right"></div>
            </div>
            <div class="item">
                <div class="left"></div>
                <div class="content" @click="forward('HEXACO-Analysis','/src/assets/personality/test5.png')">
                    <div class="image">
                        <img :src="require('/src/assets/personality/test5.png')" alt="evil">
                    </div>
                    <h3>HEXACO Analysis</h3>
                </div>
                <div class="right"></div>
            </div>
            <div class="item">
                <div class="left"></div>
                <div class="content" @click="forward('NEO-Analysis','/src/assets/personality/test6.png')">
                    <div class="image">
                        <img :src="require('/src/assets/personality/test6.png')" alt="evil">
                    </div>
                    <h3>NEO Analysis</h3>
                </div>
                <div class="right"></div>
            </div>
            <div class="item">
                <div class="left"></div>
                <div class="content" @click="forward('Eysenck-Analysis','/src/assets/personality/test7.png')">
                    <div class="image">
                        <img :src="require('/src/assets/personality/test7.png')" alt="evil">
                    </div>
                    <h3>Eysenck Analysis</h3>
                </div>
                <div class="right"></div>
            </div>
            <div class="item">
                <div class="left"></div>
                <div class="content" @click="forward('Disc-Analysis','/src/assets/personality/test8.png')">
                    <div class="image">
                        <img :src="require('/src/assets/personality/test8.png')" alt="evil">
                    </div>
                    <h3>Disc Analysis</h3>
                </div>
                <div class="right"></div>
            </div>
        </div>
        <div class="ocean">
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
          </div>
    </div>
</template>
<script>
export default {
    methods:{
        forward(val,img){
            localStorage.setItem('per-loader',img);
            this.$router.push(`/personality-land/${val}`)
        }
    }
}
</script>
<style scoped>

#container{
width:100vw;
background-color: black;
}
#content-container{
    width: 100vw;
    height:90vh;
    overflow-x: hidden;
    overflow-y:auto;
}
#content-container::-webkit-scrollbar{
    display: none;
}
#banner{
    width: 100vw;
    height: 60px;
    background:rgba(9, 218, 130, 1) ;
    color: white;
    font-family: 'Sofia';
    font-size: 32px;
    text-align: center;
    font-weight: 450;
    line-height: 60px;
    margin-bottom:10px;
}
.item{
    width: 100vw;
    height:100px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.57);
display: grid;
grid-template-columns: 1.5fr 97fr 1.5fr;
margin-top:6px;
margin-bottom:6px;
}
.left{
    width: 1.5vw;
    float: left;
    margin-left:0px;
    height: 100px;
    background: rgba(9, 218, 130, 1);
}
.right{
    width: 1.5vw;
    float: right;
    margin-right:0px;
    height: 100px;
    background: rgba(9, 218, 130, 1);
}
.content{
    width: 97vw;
    height: 100px;
    overflow: hidden;
    display: grid;
    grid-template-columns: 80px 200px;
  }
  .content h3{
    line-height: 100px;
    font-family: 'Sofia';
    font-size:27px;
    font-weight: 400;
    max-width:180px;
    overflow: hidden;
    margin-left:14px;
  }
  .image{
    width:110px;
    height: 180px;
    margin-left:5px;
    margin-top:5px;
  }
  .image img{
    width:60px;
    height:60px;
    margin-left:15px;
    margin-top:15px;
  }
  .item:hover .image img{
    animation: shake;
    animation-delay: .1s;
    animation-duration: 0.4s;
    animation-iteration-count: 1;
  }
  .item:hover .content h3{
    color:rgba(9, 218, 130, 1);
    font-weight: 590;
  }
 
  @keyframes shake {
    0% { transform: translate(1px, 1px) rotate(0deg); }
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(3px, 2px) rotate(0deg); }
    40% { transform: translate(1px, -1px) rotate(1deg); }
    50% { transform: translate(-1px, 2px) rotate(-1deg); }
    60% { transform: translate(-3px, 1px) rotate(0deg); }
    70% { transform: translate(3px, 1px) rotate(-1deg); }
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(1px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
  }
  .ocean {
    height: 80px; /* change the height of the waves here */
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-x: hidden;
  }
  
  .wave {
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 88.7'%3E%3Cpath d='M800 56.9c-155.5 0-204.9-50-405.5-49.9-200 0-250 49.9-394.5 49.9v31.8h800v-.2-31.6z' fill='rgba(9, 218, 130, 1)'/%3E%3C/svg%3E");
    position: fixed;
    width: 200%;
    height:80px;
    animation: wave 7s -3s linear infinite;
    transform: translate3d(0, 0, 0);
    opacity: 0.8;
    overflow-y: hidden;
  }
  
  .wave:nth-of-type(2) {
    bottom: 0;
    animation: wave 18s linear reverse infinite;
    opacity: 0.5;
  }
  
  .wave:nth-of-type(3) {
    bottom: 0;
    animation: wave 20s -1s linear infinite;
    opacity: 0.5;
  }
  
  @keyframes wave {
      0% {transform: translateX(0);}
      50% {transform: translateX(-25%);}
      100% {transform: translateX(-50%);}
  }
  @keyframes shake {
    0% { transform: translate(1px, 1px) rotate(0deg); }
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(3px, 2px) rotate(0deg); }
    40% { transform: translate(1px, -1px) rotate(1deg); }
    50% { transform: translate(-1px, 2px) rotate(-1deg); }
    60% { transform: translate(-3px, 1px) rotate(0deg); }
    70% { transform: translate(3px, 1px) rotate(-1deg); }
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(1px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
  }
</style>